import React, { Component } from 'react';

class NotFound extends Component {
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default NotFound;
